import React, { useState } from 'react';

import { useTranslation } from '@lt/localization';
import { Searcher as SearcherComponent } from '@lt/components';

import SearchTypeTabs from 'src/components/SearchTypeTabs';
import CigaretteSkeleton from 'src/components/CigaretteSkeleton';
import LazyCigarette from 'src/components/Cigarette/components/LazyCigarette';

import { isSSR } from 'src/helpers/ssr';

import { SEARCH_TYPE_NAMES } from 'src/constants/search';
import { TABS_PAGES } from 'src/components/SearchTypeTabs/constants';

import classnames from 'classnames';
import type { SearcherProps } from './types';

import SearcherStatus from '../../containers/Searcher/SearcherStatus';
import SearcherFormClamped from './SearcherFormClamped';

import styles from './searcher.module.css';

const Searcher = ({
  isMobile,
  isWhitelabel,
  cigaretteValues,
  searchType,
  setSearchType,
  onSubmitSearch,
  isOpenFiltersList,
  activeFilters,
  price,
  fetching,
  ...props
}: SearcherProps) => {
  // тут показываем раскрытую сигарету если
  // десктопная версия
  // и если данные получены
  const [isClamped, setClamped] = useState(isMobile && (fetching || price));

  const { t } = useTranslation();

  return (
    <div
      className={classnames({
        [styles.containerDesktop]: !isMobile,
      })}
    >
      {!isMobile && (
        <div className={styles.title}>{t('hotel.cigarette.title')}</div>
      )}
      {!isMobile && isSSR ? (
        <div
          className={classnames(styles.cigaretteContainer, {
            [styles.cigaretteContainerMobile]: isMobile,
            [styles.cigaretteContainerHotelsSearch]:
              searchType === SEARCH_TYPE_NAMES.HOTEL,
          })}
        >
          <div className={styles.tabsSkeleton} />
          <CigaretteSkeleton />
        </div>
      ) : null}
      {!isSSR ? (
        <div
          className={classnames(styles.cigaretteContainer, {
            [styles.cigaretteContainerMobile]: isMobile,
            [styles.cigaretteContainerHotelsSearch]:
              searchType === SEARCH_TYPE_NAMES.HOTEL,
          })}
        >
          <SearchTypeTabs
            className={classnames({
              [styles.searchTabMobile]: isMobile,
            })}
            selectedTab={searchType}
            setSelectedTab={setSearchType}
            variant={{
              mobile: isMobile,
              wl: isWhitelabel,
              collapsed: false,
              page: TABS_PAGES.HOTEL,
            }}
          />
          {!isClamped ? (
            <div className={styles.container}>
              <LazyCigarette
                cigaretteValues={cigaretteValues}
                isMobile={isMobile}
                searchType={searchType}
                variant="hotel"
                onSubmit={onSubmitSearch}
                allowPreview={false}
              />
            </div>
          ) : (
            <SearcherFormClamped
              cityFrom={cigaretteValues.departure.selectedLabel}
              adults={cigaretteValues.tourists.adults}
              startDate={cigaretteValues.datepicker?.left.date || undefined}
              endDate={cigaretteValues.datepicker?.right.date || undefined}
              kidsCount={cigaretteValues.tourists.kids.length}
              onExpand={() => setClamped(false)}
              isHotelOnly={searchType === SEARCH_TYPE_NAMES.HOTEL}
            />
          )}
        </div>
      ) : null}
      <SearcherComponent
        className={styles.searcherComponent}
        isMobile={isMobile}
        /* TODO: типизировать передаваемый компонент
         * @see https://leveltravel.atlassian.net/browse/LT-35957
         */
        // @ts-ignore
        SearcherStatusComponent={SearcherStatus}
        currentSearchTypeTab={searchType}
        searchType={searchType}
        isOpenFiltersList={isOpenFiltersList}
        activeFilters={activeFilters}
        fetching={fetching}
        {...props}
      />
    </div>
  );
};

export default Searcher;
